import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextoClientes = ({ lang, clientes }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-image u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-section-1" id="sec-5458" data-image-width="1386" data-image-height="926" style={{
                backgroundImage: "url(/images/web/onboard2/Jacuzzi.png)"
            }} >
                <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-title u-text-1">{t("Clientes").toUpperCase()}</h1>
            </section >
            <section className="u-clearfix u-section-2" id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                    {ReactHtmlParser(clientes.ladesc)}
                </div>
            </section>
            <section className="u-clearfix u-section-3" id="block-11">
                <div className="u-clearfix u-sheet u-valign-middle u-sheet-1">
                    <a href={"/" + preidioma + t("contacto")} className="u-align-center u-border-1 u-border-grey-80 u-border-hover-custom-color-5 u-btn u-btn-round u-button-style u-hover-custom-color-5 u-radius u-white u-btn-1" target="_blank"> {t("SOLICITA PRESUPUESTO")}</a>
                </div>
            </section>
        </>
    );

};
export default TextoClientes;
